// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__YZKoQ","legacyBtn":"MutateMid_legacyBtn__1WWs6"};